module.exports = __webpack_public_path__ + "static/media/dataviz_participations-desktop.299ad0a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dataviz_participations-desktop.svg
// module id = 139
// module chunks = 0